/**
 * constants/productionSteps.ts
 *
 * Production routing step IDs, job types, scanner station IDs, and related
 * constants. Step IDs correspond to keys in the Firebase Realtime Database
 * production-steps collection.
 */

import { includes } from 'lodash-es';
import { CONSTRUCTION_JASON } from '@lib/scanner';
import {
  bodyDataAtom, neckDataAtom, customerPartAtom,
} from '@shared/state/pricingState';

// ---------------------------------------------------------------------------
// Router step IDs
// ---------------------------------------------------------------------------

export const RUNNER_BODY_INITIAL_STEP = 'ARft0FS3O';
export const RUNNER_NECK_INITIAL_STEP = 'bIKQ9ANcC';
export const ROUTER_JOB_TYPES = ['body', 'neck'];

export const BODY_HOLD_STEP = '_ic83Hl5F';
export const NECK_HOLD_STEP = 'JRgTgTROh';
export const HOLD_STEPS = ['On Hold', NECK_HOLD_STEP, BODY_HOLD_STEP];

export const READY_STEPS = [RUNNER_BODY_INITIAL_STEP, RUNNER_NECK_INITIAL_STEP, '-sWUWMT8b', 'ro2EFSo_X'];
export const NECK_READY_STEPS = [RUNNER_NECK_INITIAL_STEP, 'ro2EFSo_X'];

export const FINISHING_STEPS = ['Finishing', 'sOspM8A0Bhx', 'DsGT5gQg-dn', 'aaKxatWdehe', 'ejhdPLv2l', '99ehk9DSkpu'];
export const COMPLETE_STEPS = ['Complete', 'vTRZZbKL9', '73TxOo4eh'];
export const DRY_ROOM_STEP = '7kN0pSmXBw3';

// ---------------------------------------------------------------------------
// Material / wood types
// ---------------------------------------------------------------------------

export const BODY_WOOD_TYPES = [
  'SwAsh', 'Alder', 'Mahog', 'Pine', 'Rst. Pine', 'Other',
];

// ---------------------------------------------------------------------------
// Recoil atom maps (used by pricing tool)
// ---------------------------------------------------------------------------

export const PART_STATE_ATOM = {
  body: customerPartAtom,
  neck: customerPartAtom,
};

export const PART_DATA_ATOM = {
  body: bodyDataAtom,
  bodyTest: bodyDataAtom,
  neck: neckDataAtom,
  neckTest: neckDataAtom,
};

// ---------------------------------------------------------------------------
// Scanner station helpers
// ---------------------------------------------------------------------------

const SCANNER_STATION_IDS = [
  'thoqTZixlrhlYxWy52GHUvNUUr42', // station-release
  'uuikiqzedJPiJ0t1zc9bJn2cDQt2', // station-assembly
  'n973nmDar7Xs7j74bmCJ8IcGlXp2', // station-construction
  CONSTRUCTION_JASON.stationId,    // station-construction-jason
  'fUl6oWOQOYSHxDkI9BVYzgi8suj1', // station-dryroom
  '7l8NTrVLWFYReCmFYnbabqNXxTe2', // station-cnc
  'kF8mOZ8sIXXAOVPjFyJty8aFCfl1', // station-finishing
  'gEmUhPcMPHeCYUCA8o0dEXdBoSo1', // station-finishing-hand
  'mAmnJq0iJAUpSCZgKC5MIOEHrTD2', // station-qa-shipping
];

export const isScannerStation = (userId: string) => includes(SCANNER_STATION_IDS, userId);
